import { Grid, TextField } from '@material-ui/core';
import React from 'react';
import { useStyles } from './SessionsCopyDialog.styles';

interface SheetDefinitionFormProps {
  examSheetName: string;
  code: string;
  handleChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

export const SheetDefinitionForm: React.FC<SheetDefinitionFormProps> = ({
  examSheetName,
  code,
  handleChange,
}: SheetDefinitionFormProps) => {
  const classes = useStyles();

  return (
    <>
      <Grid container style={{ justifyContent: 'center', margin: '12px 0px' }}>
        <div className={classes.middleText}>Zdefiniuj egzamin, do którego ma zostać przypisany kopiowany arkusz</div>
      </Grid>
      <Grid container style={{ justifyContent: 'center', marginTop: 16 }}>
        <Grid xs={12} container style={{ justifyContent: 'center' }}>
          <TextField
            id="examSheetName"
            className={`${classes.formInput} ${classes.formInputWidth}`}
            name="examSheetName"
            onChange={handleChange}
            required
            label="Nazwa"
            value={examSheetName}
            placeholder="Nazwa"
            variant="outlined"
            inputProps={{
              style: {
                padding: '15.5px',
              },
            }}
          />
        </Grid>
        <Grid xs={12} container style={{ justifyContent: 'center', marginTop: 12 }}>
          <TextField
            id="code"
            className={`${classes.formInput} ${classes.formInputWidth}`}
            name="code"
            onChange={handleChange}
            required
            label="Kod"
            value={code}
            placeholder="Kod"
            variant="outlined"
            inputProps={{
              style: {
                padding: '15.5px',
              },
            }}
          />
        </Grid>
      </Grid>
    </>
  );
};
